import { createStore } from 'vuex'

export default createStore({
  state: {
    userInfo: JSON.parse(localStorage.getItem("LoginUser")),
    patient: JSON.parse(localStorage.getItem("MMPatient"))
  },
  mutations: {
    setUserInfo(state, value) {
      state.userInfo = value
    },
    setPatient(state, value) {
      state.patient = value
    }
  },
  actions: {
  },
  modules: {
  }
})
